import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Decorative motion only: never hide controls or block reading/navigation. */
export default function SiteMotion() {
  const { pathname } = useLocation();

  useEffect(() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (preference.matches || !('IntersectionObserver' in window)) return;
    const targets = document.querySelectorAll<HTMLElement>(
      '.trust-item, .section-heading, .step, .analysis-preview, .dosha-card, .benefit, .doctor-portrait, .doctor-copy, .faq-list details, .closing-cta, .footer-grid > div',
    );
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('motion-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    const revealAll = () => {
      if (preference.matches) {
        targets.forEach(el => el.classList.add('motion-visible'));
        observer.disconnect();
      }
    };
    targets.forEach(el => {
      el.classList.add('motion-reveal');
      observer.observe(el);
    });
    preference.addEventListener('change', revealAll);
    return () => {
      observer.disconnect();
      preference.removeEventListener('change', revealAll);
      targets.forEach(el => el.classList.remove('motion-reveal', 'motion-visible'));
    };
  }, [pathname]);

  return null;
}
